import { PeTypes } from '@platform/types';
import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

const useWorkspaces = (userId: number) =>
  useQuery<PeTypes.Workspace[]>(['workspaces', userId], () => peApi.getWorkspaces(), { enabled: userId !== -1 });

export default useWorkspaces;
